import { useMutation, useQueryClient } from 'react-query'

import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { catalogAccessRepository } from '@webapp/modules/purchasing/data-access/repositories/CatalogAccessRepository'
import { catalogAccessQueryConfig } from '@webapp/modules/purchasing/query-configs/catalogAccess'

export const useToggleCatalogPermissionModel = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation<void, RepoError, boolean>({
    mutationFn: (value: boolean) =>
      catalogAccessRepository.setCatalogPermissionEnabled(value),
    onSuccess: () => {
      queryClient.invalidateQueries(
        catalogAccessQueryConfig.permissionEnabled().queryKey
      )
    },
  })

  return {
    mutate: mutation.mutate,
    isLoading: mutation.isLoading,
  }
}
